module.exports = __webpack_public_path__ + "img/mixpanel.4379e5bc.jpg";